export var BaseDict = {
    Example: "Translated Example",
    ReadMore: "Read More",
    ReadLess: "Read Less"
};
//# sourceMappingURL=dict.js.map